// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"adqS3","isSelected":"e5P9N"};